import VendorWiseRating from "../component/VendorWiseRating";
import requests from "./httpService";

const FeedbackServices = {

    getFeedback : async () =>{
        return requests.get(`/reviewservice`);
    },

    updateApointment : async (id,body) =>{
        return requests.patch(`/reviewservice/${id}`,body);
    },


    perVendorWiseRating : async (vendorId) =>{
        return requests.get(`/vendor-review-by-user/vendor/${vendorId}/reviews`);
    },

    updateFeedbackStatus : async (id,body) =>{
        return requests.patch(`/reviewservice/status/${id}`,body);
    },

    deleteFeedback  : async (id) =>{
        return requests.delete(`/reviewservice/${id}`);
    },
 
    getAllReviews : async () =>{
        return requests.get(`/vendor-review-by-user/vendor-review`);
    },

}

export default FeedbackServices;